export default "__VITE_ASSET__Cd1pggUI__"